import axios from "axios";

const incrementButtons = [...Array.from(document.querySelectorAll('[data-increment]'))] as HTMLButtonElement[];
const decrementButtons = [...Array.from(document.querySelectorAll('[data-decrement]'))] as HTMLButtonElement[];
const numberInputs = [...Array.from(document.querySelectorAll('input[type="number"]'))] as HTMLInputElement[];
const radioInputs = [...Array.from(document.querySelectorAll('input[type="radio"]'))] as HTMLInputElement[];
const calculatedSavings = [...Array.from(document.querySelectorAll('span[data-calculatedsavings]'))] as HTMLSpanElement[];

function getAdults() {
	const adultsInput = document.querySelector('input[id="adults"]') as HTMLInputElement;

	if (adultsInput) {
		return adultsInput.valueAsNumber;
	}

	return 0;
}

function getChildren() {
	const childrenInput = document.querySelector('input[id="children"]') as HTMLInputElement;

	if (childrenInput) {
		return childrenInput.valueAsNumber;
	}

	return 0;
}

function isPass() {
	const passInput = document.querySelector('input[id="PassInput"]') as HTMLInputElement;

	if (passInput) {
		return passInput.checked;
	}

	return false;
}

function getPassName() {
	const passNameInput = document.querySelector('input[name="passname"]:checked') as HTMLInputElement;

	if (passNameInput) {
		return passNameInput.value;
	}

	return "";
}

function isNew() {
	const passNewInput = document.querySelector('input[id="PassNew"]') as HTMLInputElement;

	if (passNewInput) {
		return passNewInput.checked;
	}

	return false;
}

function getAttractionEntrances() {
	const attractionInputs = [...Array.from(document.querySelectorAll('[data-attraction]'))] as HTMLInputElement[];
	const attractionsEntrances = new Array();

	attractionInputs.forEach((attraction: HTMLInputElement) => {
		const attractionObj = {
			attractionId: attraction.getAttribute('id'),
			entrances: attraction.valueAsNumber
		};

		attractionsEntrances.push(attractionObj);
	});

	return attractionsEntrances;

}

function stopAnimation(value: string) {
	calculatedSavings.forEach((span: HTMLSpanElement) => {
		span.textContent = value;
		span.classList.remove('animate');
	});
}

function startAnimation() {
	calculatedSavings.forEach((span: HTMLSpanElement) => {
		span.textContent = '...';
		span.classList.add('animate');
	});
}


// create a source variable which we will later assign cancel token using the CancelToken.source factory.
let source: any;

function update() {
	startAnimation();

	// Check if a CancelToken.source has been assigned to the source variable, then call the cancel method when true.
	if (source) {
		source.cancel('Operation canceled by the user.');
	}

	source = axios.CancelToken.source();

	const calculatorData = {
		adults: getAdults(),
		children: getChildren(),
		isPass: isPass(),
		passType: getPassName(),
		isNew: isNew(),
		attractionsEntrances: getAttractionEntrances(),
	};

	// Send a POST request
	axios.post('/umbraco/api/mapsavingscalculator/getsavings', calculatorData, {
		cancelToken: source.token
	})
	.then((response) => {
		stopAnimation(response.data);
	})
	.catch((error) => {
		if (axios.isCancel(error)) {
			console.log('Request canceled', error.message);
		} else {
			if (error.response) {
				// Request made and server responded
				console.log(error.response.data);
				console.log(error.response.status);
				console.log(error.response.headers);
			} else if (error.request) {
				// The request was made but no response was received
				console.log(error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.log('Error', error.message);
			}
		}

		stopAnimation('');
	});

}

function addEventListeners() {

	radioInputs.forEach((el: HTMLInputElement) => {
		el.addEventListener('click', () => {
			const discoveryRadio = document.querySelector('input[type="radio"][value="Discovery"]') as HTMLInputElement;
			const membershipRadio = document.querySelector('input[type="radio"][id="MembershipInput"]') as HTMLInputElement;
			const renewalRadio = document.querySelector('input[type="radio"][id="PassRenewal"]') as HTMLInputElement;

			discoveryRadio.disabled = false;
			if (membershipRadio.checked || renewalRadio.checked) {
				discoveryRadio.checked = false;
				discoveryRadio.disabled = true;
			}

			update();
		});
	});

	incrementButtons.forEach((el: HTMLButtonElement) => {
		el.addEventListener('click', () => {
			const parent = el.closest('.savings-calculator-amount-wrapper') as HTMLDivElement;
			const input = parent.querySelector('input') as HTMLInputElement;
			let max = Number(input.getAttribute('max'));

			if (input.valueAsNumber === max) return;

			input.valueAsNumber = input.valueAsNumber + 1;
			update();
		});
	});

	decrementButtons.forEach((el) => {
		el.addEventListener('click', () => {
			const parent = el.closest('.savings-calculator-amount-wrapper') as HTMLDivElement;
			const input = parent.querySelector('input') as HTMLInputElement;
			let min = Number(input.getAttribute('min'));

			if (input.valueAsNumber === min) return;

			input.valueAsNumber = input.valueAsNumber - 1;
			update();
		});
	});

	numberInputs.forEach((el) => {
		el.addEventListener('input', (e) => {
			// If entered value i s larger than max set value to max value

			const target = e.target as HTMLInputElement;

			if (target.valueAsNumber > Number(target.getAttribute('max'))) {
				target.valueAsNumber = Number(target.getAttribute('max'));
			}
			update();
		});
		/*
		el.addEventListener('blur', (e) => {
			if(e.target.value === '' || e.target.valueAsNumber === 0) {
				e.target.value = 0;
			}
			if(e.target.valueAsNumber.toString().startsWith('0')) {
				e.target.value = e.target.valueAsNumber;
			}
			update();
		});
		*/
	});

}

addEventListeners();